//import NPM, LIB
import React, { Component, useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";
import { connect, useDispatch, useSelector } from "react-redux";
import ReactDOM from "react-dom";
import MicroModal from "micromodal";
import Moment from "moment";
import Highlighter from "react-highlight-words";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import latinize from "latinize";
import Lightbox from "react-image-lightbox";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBrLocale from "date-fns/locale/pt-BR";
import ReactHtmlParser from "react-html-parser";
import { sub, format } from "date-fns";

//import ACTIONS
import {
  CarregamentoInteractions,
  GetHistory,
  dbfileSize,
  InteracoesContactNumber,
  GetInteractionsContact,
  GetPhoneMidia,
  SearchingHistoryData,
  DownloadFile,
  GetInteractionsModal,
  GetDetailsContacts,
  InterationNotifier,
  RequestActiveCallSocketVoz,
  ReturningCallback,
  returnListCallQueue,
  RequestActiveCall,
  ShowInfoDisplay,
  AddNumberContact,
} from "../../../../actions";
import {
  Tooltip,
  Popover,
  Topover,
  Tooltippy,
} from "../../../../actions/Tippy";
import { handleFiles } from "../../../../actions/files";

//import COMPONENTS
import PdfDocument from "../../../templates/PdfDocument";
import Typography from "../../../Typography";
import Loading from "../../../Loading";
import Audio from "../../../Audio/Audio";
import Table from "../../../table/Table";
import InteractionComment from "../../../InteractionComment/InteractionComment";
import UserPhoto from "../../../UserPhoto/userphoto";
import FieldContainer from "../../../FieldContainer/FieldContainer";

//import CSS
import "../../../../build/css/modal.css";
import "./interactions-historic-modal.css";

//import SVG,IMG
import WHATSAPP from "../../../../build/images/t-whatsapp.svg";
import ICONPDFEXPORT from "../../../../build/images/pdf.svg";
import VIDEO from "../../../../build/images/video.jpg";
import AUDIO from "../../../../build/images/audio.svg";
import FOTO from "../../../../build/images/foto.svg";
import DOC from "../../../../build/images/doc.svg";
import AVI from "../../../../build/images/avi-file.png";
import JPG from "../../../../build/images/jpg-file.png";
import XLS from "../../../../build/images/media-icon.png";
import PDF from "../../../../build/images/pdf-file.png";
import MP3 from "../../../../build/images/mp3-file.png";
import WEBCHATICON from "../../../../build/images/webchat-new.svg";
import TWITTER from "../../../../build/images/twitter-new.svg";
import MIDIAFACE from "../../../../build/images/facebook_new.svg";
// import MIDIAZAP from "../../../../build/images/whatsapp_new.svg";
import { ReactComponent as SMSICON } from "../../../../build/images/sms-new.svg";
import MIDIAZAP from "../../../../build/images/icons-channels/whatsapp2-large.svg";
import MIDIAEMAIL from "../../../../build/images/email-new.svg";
import MIDIAWEB from "../../../../build/images/webchat-new.svg";
import CALLCHAT from "../../../../build/images/callchat-new.svg";
import TELEGRAM from "../../../../build/images/channels/telegram.svg";
import MIDIATELEGRAM from "../../../../build/images/telegram-new.svg";
import GOOGLEGBM from "../../../../build/images/googlegbm-new.svg";
import LINKEDIN from "../../../../build/images/linkedin-new.svg";
import INSTAGRAM from "../../../../build/images/instagram_new.svg";
import CLIENTE from "../../../../build/images/user.svg";
import TEAMS from "../../../../build/images/channelsNew/teamsBig.svg";
import { ReactComponent as IconMessageNull } from "../../../../build/images/messages-3.svg";
import { ReactComponent as HappyRating } from "../../../../build/images/icons-rating/happy.svg";
import { ReactComponent as IndifRating } from "../../../../build/images/icons-rating/indifferent.svg";
import { ReactComponent as SadRating } from "../../../../build/images/icons-rating/sad.svg";
import { ReactComponent as NullRating } from "../../../../build/images/icons-rating/star-slash.svg";
import { ReactComponent as IconSeeInteraction } from "../../../../build/images/messages-2.svg";
import { ReactComponent as IconDownloadAudio } from "../../../../build/images/direct-inbox.svg";
import { ReactComponent as IconDoc } from "../../../../build/images/attendanceIcons/document-text.svg";
import { ReactComponent as ArrowLeft } from "../../../../build/images/arrow-left.svg";
import unicodeToChar from "../../../../actions/formatUnicode";
import blockClick from "../../../../actions/blockClick";
import { formatMimeType56 } from "../../../../utils/formatMimetype56";

const { connection_platform } = require("../../../../services/api");
const { meses } = require("../../../../services/data");

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var clientTest = "";

port = localStorage.getItem("port");

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

function isJson(item) {
  item = typeof item != "string" ? JSON.stringify(item) : item;

  try {
    item = JSON.parse(item);
  } catch (e) {
    return false;
  }

  if (typeof item === "object" && item != null) {
    return true;
  }

  return false;
}

function tratarUnderline(valor) {
  valor = valor.split(" ");
  const expresionRegular = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  let valorFim = [];
  for (let variavel of valor) {
    if (!expresionRegular.test(variavel)) {
      variavel = variavel
        .replace(/(?:\*)([^*<\n]+)(?:\*)/g, "<strong>$1</strong>")
        .replaceAll("\n", "</br>")
        .replaceAll('"}', "")
        .replaceAll("\\n", "</br>")
        .replaceAll("\n", "</br>")
        .replaceAll("\\r", "")
        .replaceAll("\r", "")
        .replace(/_(.*?)_/g, "<em>$1</em>");
    }
    valorFim.push(unicodeToChar(variavel));
  }
  return valorFim.join(" ");
}

function tratarMSG(item) {
  var mensagem_tratada = item;
  mensagem_tratada = item.replace(/¿/gi, "\n");
  mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
  let valor = 1;
  try {
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    var obj = JSON.parse(mensagem_tratada);
    mensagem_tratada = obj[1][0].mensagem_tratada;
  } catch (e) {
    mensagem_tratada = item;
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/\r\n/gi, "ªª");
    mensagem_tratada = mensagem_tratada.replace(/"/gi, "");
    mensagem_tratada = mensagem_tratada.replace(
      /[^A-ZÀ-Ú a-zà-ú 0-9 , . ? ! * {2}# ; : '-' _ + § ¿ { } ' " ª \\ \ ]/g,
      ""
    );
    mensagem_tratada =
      '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
    try {
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
      mensagem_tratada = mensagem_tratada.replace(/ªª/gi, "\r\n");
    } catch (e) {
      mensagem_tratada = item;
    }
  }
  return mensagem_tratada;
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}

let dateinitinteraction = sub(new Date(), {
  days: 7,
});
let dateendinteraction = new Date();

export default function InteractionsHistoricModal({
  changeModal = false,
  IdContact,
  displayscreen,
  monitorclient,
}) {
  const dispatch = useDispatch();
  let pdfExportComponent = useRef();

  port = localStorage.getItem("port");

  // const IPCurrent = useSelector((state) => state.ipcurrent);
  // const PermissionRouter = useSelector((state) => state.routergroups);
  // const OutBandService = useSelector((state) => state.outservices);
  // const StatusAgent = useSelector((state) => state.status);
  // const listCallQueue = useSelector((state) => state.listcallqueue);
  // const AtdSimult = useSelector((state) => state.atdsimult);
  const InfoUsers = useSelector((state) => state.informationusers);

  const InteractionsNumber = useSelector((state) => state.interactions);
  const HistorysFromRedux = useSelector((state) => state.history);
  const contactId = useSelector((state) => state.atendimento);
  const Mimetypes = useSelector((state) => state.mimetypes);
  const infoModal = useSelector((state) => state.interactionsmodal);
  const DetailsContacts = useSelector((state) => state.detailscontacts);

  const [interactions, setInteractions] = useState([]);
  const [changeInteractions, setChangeInteractions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [historys, setHistorys] = useState([]);
  const [dateInit, setDateInit] = useState(dateinitinteraction);
  const [dateEnd, setDateEnd] = useState(dateendinteraction);
  // const [clientOption, setClientOption] = useState(atendimento);
  const [mensagem, setMensagem] = useState("");
  const [termText, setTermText] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingHis, setLoadingHis] = useState(false);
  const [ContactId, setContactId] = useState({});
  const [originModal, setOriginModal] = useState("");
  const [textSearchContacts, setTextSearchContacts] = useState("");
  const [linkContact, setLinkContact] = useState("");
  const [viewContacts, setViewContacts] = useState(false);
  const [listSearchContacts, setListSearchContacts] = useState([]);
  const [typeModal, setTypeModal] = useState("link");

  const searchWords = searchText.split(/\s/).filter((word) => word);
  let dia = "";
  let auxdia = "";

  const mimetypesPrincipal = [
    "image",
    "voice",
    "document",
    "audio",
    "txt",
    "video",
  ];

  function searchHistoryContact(numeroCliente) {
    let histstart = format(dateInit, "yyyy-MM-dd") + "T00:00";
    let histend = format(dateEnd, "yyyy-MM-dd") + "T23:59";
    let idgroup = InfoUsers.idgroup;
    setLoadingHis(true);
    dispatch(
      SearchingHistoryData(histstart, histend, 33, numeroCliente, idgroup)
    );
    // setDateInit(histstart + "T00:00");
    // setDateEnd(histend + "T23:59");
  }

  function exitModal(e, modal) {
    // if (originModal === "contacts") {
    //   MicroModal.close("modal__historico-atendimento-details");
    //   MicroModal.show("modal__agenda");
    // } else if (originModal === "") {
    MicroModal.close("modal__historico-atendimento-details");
    dispatch(GetInteractionsModal("", ""));
    setDateInit(dateinitinteraction);
    setDateEnd(dateendinteraction);
    // }
  }

  function showAllHistory(e, idcdr, data) {
    // dispatch(GetInteractionsModal(ContactId.cliente, ContactId.telefone));
    clientTest = ContactId.cliente;

    let idgroup = InfoUsers.idgroup;
    dispatch(GetHistory([]));

    // setTimeout(() => {
    dispatch(CarregamentoInteractions(idcdr, idgroup));
    MicroModal.close("modal__agenda-pf__cliente__interacoes__duplicado");
    MicroModal.show("modal__historico-atendimento-contact-2");
    // }, 1000);
  }

  function searchInHistoryContact(e) {
    e.preventDefault();
    setShowHistory(!showHistory);
    setTermText("");
  }

  function closeHistory(e) {
    dispatch(GetHistory([]));
    MicroModal.close("modal__historico-atendimento-contact-2");
    MicroModal.show("modal__historico-atendimento-details");
  }

  function getInteractions(e, number, contactid) {
    e.preventDefault();
    let idgroup = InfoUsers.idgroup;
    const datainit = format(dateInit, "yyyy-MM-dd") + "T00:00";
    const datafim = format(dateEnd, "yyyy-MM-dd") + "T23:59";
    setLoading(true);
    // dispatch(GetInteractionsContact([]));
    dispatch(
      InteracoesContactNumber(
        number,
        datainit,
        datafim,
        mensagem,
        idgroup,
        contactid
      )
    );
    dispatch(GetPhoneMidia([]));
  }

  function exportPDFWithMethod(ContactId) {
    let element = document.querySelector(".pdf-export");
    // savePDF(ReactDOM.findDOMNode(pdfExportComponent), {
    //   paperSize: "A4",
    //   margin: 10,
    //   fileName: ContactId.cliente + "_" + ContactId.telefone + ".pdf",
    // });
    savePDF(element, {
      paperSize: "A4",
      margin: 10,
      fileName: ContactId.cliente + "_" + ContactId.telefone + ".pdf",
    });
  }

  function exportPDFWithComponent() {
    pdfExportComponent.save();
  }

  function defaultSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data;
    const objectRowB = rowB.original[columnId].data;

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;
    return 0;
  }

  function customSorting(rowA, rowB, columnId) {
    const customRowA = rowA.original[columnId].config.customOrder;
    const customRowB = rowB.original[columnId].config.customOrder;

    if (customRowA > customRowB) return -1;
    if (customRowB > customRowA) return 1;
    return 0;
  }

  function channelIcon(idmidia) {
    if (idmidia === 1) {
      return (
        <div className="icon-container">
          <img
            alt="Logo Chamada de Voz"
            src={CALLCHAT}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 2) {
      return (
        <div className="icon-container">
          <img alt="Logo Web" src={MIDIAWEB} className="icon-container__icon" />
        </div>
      );
    } else if (idmidia === 6) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Instagram"
            src={INSTAGRAM}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 5) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Whatsapp"
            src={MIDIAZAP}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 3) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Email"
            src={MIDIAEMAIL}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 4) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Facebook"
            src={MIDIAFACE}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 8) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Telegram"
            src={MIDIATELEGRAM}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 9) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Twitter"
            src={TWITTER}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 10) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do LinkedIn"
            src={LINKEDIN}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 11) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do LinkedIn"
            src={GOOGLEGBM}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 12) {
      return (
        <div className="icon-container">
          <div className="icon-container__svg">
            <SMSICON />
          </div>
        </div>
      );
    } else if (idmidia === 15) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do teams"
            src={TEAMS}
            className="icon-container__icon"
          />
        </div>
      );
    }
  }

  function exhibMessage(interaction) {
    if (interaction.idmidia === 1) {
      let url = interaction.filerecord;
      let name = "Sem arquivo";
      let namefile;
      if (url) {
        url = url.replace("192.168.178.2", "\\" + interaction.change_path);
        namefile = url.split("\\").pop().split("#")[0].split("?")[0];
      }
      const audioLink =
        connection_platform.type_connect + "://" + ipcurrent + url;
      return (
        <div className="message-table">
          <Audio audio link={InfoUsers.permreproduce ? audioLink : ""} />
        </div>
      );
    } else if (
      interaction.mensagem === null ||
      interaction.mensagem === "" ||
      interaction.mensagem === ""
    ) {
      return (
        <div className="message-table">
          <Typography.H6 color={"gray-125"}>
            Sem mensagem de texto
          </Typography.H6>
        </div>
      );
    } else {
      if (isJson(interaction.mensagem) === true) {
        let json = JSON.parse(interaction.mensagem);
        let options = json.options;
        let i = 1;
        var opcoes = [];
        for (i in options) {
          opcoes.push(i + " - " + options[i][1]);
        }
        let mensagem = json.msg + " \r\n ";
        return (
          <div
            className="message-table"
            style={{ pointerEvents: "none" }}
            onClick={(event) => blockClick(event)}
          >
            <Typography.H6 color={"gray-180"}>
              {ReactHtmlParser(`<p>${mensagem}</p>`)}
            </Typography.H6>
          </div>
        );
      } else {
        var mensagem_tratada = interaction.mensagem;
        let valor = 1;
        try {
          mensagem_tratada =
            '{"' +
            valor +
            '": [{"mensagem_tratada":"' +
            mensagem_tratada +
            '"}]}';
          var obj = JSON.parse(mensagem_tratada);
          mensagem_tratada = obj[1][0].mensagem_tratada;
        } catch (e) {
          mensagem_tratada = interaction.mensagem;
        }
        mensagem_tratada = unicodeToChar(mensagem_tratada);
        mensagem_tratada = tratarUnderline(mensagem_tratada);
        if (interaction.idmidia === 3) {
          return (
            <div className="message-table__email">
              <Typography.H6 color={"gray-180"}>
                {ReactHtmlParser(mensagem_tratada)}
              </Typography.H6>
            </div>
          );
        } else {
          return (
            <div
              className="message-table"
              style={{ pointerEvents: "none" }}
              onClick={(event) => blockClick(event)}
            >
              <Typography.H6 color={"gray-180"}>
                {ReactHtmlParser(mensagem_tratada)}
              </Typography.H6>
            </div>
          );
        }
      }
    }
  }

  function renderAvaliation(atd) {
    switch (atd.resultado) {
      case "otimo":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag happy">
              <HappyRating />
            </div>
          </Tooltippy>
        );

      case "promotor":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag happy">
              <HappyRating />
            </div>
          </Tooltippy>
        );

      case "razoavel":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag indifferent">
              <IndifRating />
            </div>
          </Tooltippy>
        );

      case "neutro":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag indifferent">
              <IndifRating />
            </div>
          </Tooltippy>
        );

      case "ruim":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag sad">
              <SadRating />
            </div>
          </Tooltippy>
        );

      case "detrator":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag sad">
              <SadRating />
            </div>
          </Tooltippy>
        );

      default:
        return (
          <div className="username-rating__tag">
            <NullRating />
          </div>
        );
    }
  }

  function renderIconsHistoric(interaction) {
    if (interaction.idmidia === 1) {
      let url = interaction.filerecord;
      let name = "Sem arquivo";
      let namefile;
      if (url) {
        url = url.replace("192.168.178.2", "\\" + interaction.change_path);
        namefile = url.split("\\").pop().split("#")[0].split("?")[0];
      }

      return (
        <IconDownloadAudio
          className={`icon-actions ${
            interaction.filerecord && InfoUsers.permdownload
              ? ""
              : "message-null"
          }`}
          onClick={(event) =>
            interaction.filerecord && InfoUsers.permdownload
              ? dispatch(
                  DownloadFile(
                    connection_platform.type_connect + "://" + ipcurrent + url,
                    namefile
                  )
                )
              : null
          }
        />
      );
    } else {
      if (InfoUsers.permreproduce === true) {
        return (
          <IconSeeInteraction
            className={`icon-actions ${
              interaction.mensagem ? "" : "message-null"
            }`}
            onClick={(event) =>
              interaction.mensagem
                ? showAllHistory(event, interaction.idcdr, interaction.datarc)
                : null
            }
          />
        );
      } else {
        return <IconSeeInteraction className={`icon-actions message-null`} />;
      }
    }
  }

  function refactorInteractionsData(data) {
    let dataRefactored = [];

    data.forEach((datum) => {
      const formatDate = datum.datarec.split(" ");
      const dateGet = formatDate[0];
      const hourGet = formatDate[1];

      const splitDate = dateGet.split("/");
      const reverseDate = splitDate.reverse();
      const dateOrder = `${reverseDate.join("/")} ${hourGet}`;

      if (datum.mensagem && datum.mimetypeid === 56) {
        const tempDatum = { ...datum, messagem: datum.mensagem };
        const treated = formatMimeType56(tempDatum, "");
    
        if (treated) {
          datum.mensagem = treated;
        }
      }

      const fileShareRefactored = {
        channel: {
          data: channelIcon(datum.idmidia),
          config: {
            textEllipsis: true,
            customOrder: datum.idmidia,
          },
        },
        subject: {
          data: (
            <Typography.H6 color={"gray-180"}>
              {datum.idmidia === 3
                ? datum.assunto
                : datum.subservico === null
                ? "Saída"
                : datum.subservico}
            </Typography.H6>
          ),
          config: {
            textEllipsis: true,
            customOrder: datum.assunto,
          },
        },
        message: {
          data: exhibMessage(datum),
          config: {
            textEllipsis: true,
            customOrder: datum.mensagem ? datum.mensagem : "zzzz",
          },
        },
        operator: {
          data: (
            <Typography.H6 color={"gray-180"}>{datum.username}</Typography.H6>
          ),
          config: {
            textEllipsis: true,
          },
        },
        date: {
          data: (
            <Typography.H6 color={"gray-180"}>{datum.datarec}</Typography.H6>
          ),
          config: {
            textEllipsis: true,
            customOrder: new Date(dateOrder),
          },
        },
        avaliation: {
          data: renderAvaliation(datum),
          config: {
            textEllipsis: true,
            customOrder: datum.nota,
          },
        },
        action: {
          data: renderIconsHistoric(datum),
          config: {
            textEllipsis: true,
          },
        },
      };

      dataRefactored.push(fileShareRefactored);
    });

    return dataRefactored;
  }

  const columns = [
    {
      Header: "Canal",
      accessor: "channel",
      id: "channel",
      sortType: customSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "Assunto",
      accessor: "subject",
      id: "subject",
      sortType: customSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "Mensagem",
      accessor: "message",
      id: "message",
      sortType: customSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "Operador",
      accessor: "operator",
      id: "operator",
      sortType: defaultSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "Data",
      accessor: "date",
      id: "date",
      sortType: customSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "Satisfação",
      accessor: "avaliation",
      id: "avaliation",
      sortType: customSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "",
      accessor: "action",
      id: "action",
      disableSortBy: true,
      disableFilters: true,
      display: true,
    },
  ];

  const interactionsData = useMemo(() => {
    if (changeInteractions.length !== 0) {
      const dataRefactored = refactorInteractionsData(changeInteractions);

      setLoading(false);
      return dataRefactored;
    }
  }, [changeInteractions]);

  async function refactorHistory() {
    const processed = [];
    for (const history of HistorysFromRedux) {
      const newHistory = { ...history };

      const hasMessagem = !!newHistory && !!newHistory.messagem;
      if (hasMessagem) {
        newHistory.messagem = newHistory.messagem.replace(
          /\\U([0-9a-fA-F]{8})/g,
          (match, hex) => {
            return String.fromCodePoint(parseInt(hex, 16));
          }
        );
      }

      if (
        mimetypesPrincipal.includes(newHistory.typename) &&
        !newHistory.messagem.includes("https")
      ) {
        const response = await handleFiles(newHistory.messagem);

        if (response) {
          try {
            const fileObject = {
              name: response.name,
              size: response.size,
              type: response.typeMime,
              path_arquivos: newHistory.messagem,
              extension: response.type,
              id: newHistory.id,
            };
            newHistory.file = fileObject;
          } catch (error) {
            return true;
          }
        }

        //Busca as informações do mimetype caso venha o link completo do arquivo
      } else if (
        mimetypesPrincipal.includes(newHistory.typename) &&
        newHistory.messagem.includes("https")
      ) {
        const mimetype = Mimetypes.find(
          (element) => newHistory.mimetypeid === element.id
        );
        newHistory.mimetype = mimetype;

        //Caso a mensagem seja um json, ele faz o parse para ler o json
      } else if (newHistory.typename === "application") {
        // history.messagem = JSON.parse(history.messagem).msg || JSON.parse(history.messagem).MSG;
        try {
          if (
            JSON.parse(newHistory.messagem).msg ||
            JSON.parse(newHistory.messagem).MSG
          ) {
            newHistory.messagem =
              JSON.parse(newHistory.messagem).msg ||
              JSON.parse(newHistory.messagem).MSG;
          }

          newHistory.messagem = createJSON(newHistory.messagem);
        } catch (err) {
          console.log("Error: ", err.message);
        }

        //Caso seja auditória de voz, formata o link que vem do back (vem sem formatação) para poder chamar a função que busca as informações do arquivo.
      } else if (newHistory.typename === "Interactive") {
        if (newHistory.mimetypeid >= 33 && newHistory.mimetypeid <= 36) {
          try {
            let sanitizedMessage = newHistory.messagem.replace(
              /[\u0000-\u001F\u007F-\u009F]/g,
              ""
            );
            let json = JSON.parse(sanitizedMessage);

            newHistory.buttons = json.buttons;
            newHistory.botid = json.botid;

            if (!!json && !!json.msg && typeof json.msg === "string") {
              newHistory.messagem = json.msg;
            }

            if (json.link) {
              const response = await handleFiles(json.link);
              try {
                const fileObject = {
                  name: response.name,
                  size: response.size,
                  type: response.typeMime,
                  path_arquivos: json.link,
                  extension: response.type,
                  id: newHistory.id,
                };
                newHistory.file = fileObject;
              } catch (error) {
                console.error("Erro ao processar arquivo:", error);
                return true;
              }
            }
          } catch (error) {
            console.error("JSON inválido em history.messagem:", error);
            return true; // Ou outro tratamento que faça sentido para seu caso
          }
        } else if (newHistory.mimetypeid === 37) {
          try {
            let message = newHistory.messagem.replaceAll("\r\n", "\\n");
            let json = JSON.parse(message);
            newHistory.botid = json.botid;
            newHistory.buttons = json.items;
          } catch (error) {
            let json = {};
          }
        } else if (newHistory.mimetypeid === 50) {
          let message = newHistory.messagem.replaceAll("\r\n", "\\n");
          // let json = JSON.parse(message);
          let json;
          try {
            // tenta parsear como JSON string
            json = JSON.parse(message);
          } catch (e) {
            // se der erro, já é objeto
            json = message;
          }
          let msgFinal = "";

          if (typeof json === "object" && json !== null && json.botid) {
            let msg = json.msg;
            if (json.header) {
              msg = `*${json.header}*\n${msg}\n`;
            }

            msgFinal = msg;

            newHistory.buttons = [
              {
                text: json.footer,
                flowCta: json.flow_cta,
              },
            ];
            newHistory.botid = json.botid;
          } else if (typeof json === "object" && json !== null) {
            let newMsg = Object.entries(json)
              .filter(([key]) => key !== "flow_token")
              .map(([key, value]) => `*${key}*\n_${value}_\n`)
              .join("");
            msgFinal = newMsg;
          }

          newHistory.messagem = msgFinal;
        }
      } else if (newHistory.typename === "location") {
        let json = JSON.parse(newHistory.messagem);
        newHistory.location = {
          latitude: json.latitude ? json.latitude : json.LATITUDE,
          longitude: json.longitude ? json.longitude : json.LONGITUDE,
          nomeEndereco: json.name ? json.name : json.NAME,
          endereco: json.address ? json.address : json.ADDRESS,
        };
      } else if (newHistory.typename === "hsm") {
        const verifyJson = isJson(newHistory.messagem);
        // let json = "";

        if (!verifyJson) {
          newHistory.messagem = JSON.stringify(
            newHistory.messagem.replace(/'/g, '"')
          );
          // .replace(/\'/g, '"');
        }

        let json = JSON.parse(newHistory.messagem);

        if (typeof json === "string") {
          try {
            const tempJson = JSON.parse(
              json
                .replaceAll("\\u2060", " ")
                .replaceAll("\\n", "¿quebraLinhaN¿")
                .replaceAll("\\r", "¿quebraLinhaN¿")
                .replaceAll("\\", "")
                .replaceAll("¿quebraLinhaN¿", "\\n")
                .replaceAll('""', '"')
                .replaceAll('"{', "{")
                .replaceAll('}"', "}")
            );
            if (!!tempJson) {
              json = tempJson;
            }
          } catch (error) {}
        }

        if (json.FILEPATH) {
          const response = await handleFiles(json.FILEPATH);
          const hasResponse = !!response;
          if (hasResponse) {
            const fileObject = {
              name: response.name,
              size: response.size,
              type: response.typeMime,
              path_arquivos: json.FILEPATH,
              extension: response.type,
              id: newHistory.id,
            };
            newHistory.file = fileObject;

            newHistory.messagem = json.URL;
          }
          if (!!json && !!json.URL && typeof json.URL === "string") {
            newHistory.messagem = json.URL;
          }
        }

        if (json.HSM_BUTTONS) {
          newHistory.messagem = json.URL;
          if (!!json && !!json.URL && typeof json.URL === "string") {
            newHistory.messagem = json.URL.replace(/\r\n/g, "</br>")
              .replace(/\n/g, "</br>")
              .replace(/\r/g, "</br>");
          }

          let buttonsFormated = [];
          if (json.HSM_BUTTONS.buttons) {
            const buttons = json.HSM_BUTTONS.buttons;
            for (const btn of buttons) {
              const objBtn = {
                payload: btn.index,
                text: btn.parameters[0].text,
              };

              buttonsFormated.push(objBtn);
            }
          } else {
            const buttons = json.HSM_BUTTONS;
            const isButtonsArray = Array.isArray(buttons);
            if (isButtonsArray) {
              for (const btn of buttons) {
                const objBtn = {
                  payload: btn.payload.index,
                  text: btn.payload.value,
                };

                buttonsFormated.push(objBtn);
              }
            } else if (typeof buttons === "object" && "payload" in buttons) {
              const btn = buttons;
              const objBtn = {
                payload: btn.payload.index,
                text: btn.payload.value,
              };

              buttonsFormated.push(objBtn);
            }
          }

          newHistory.buttons = buttonsFormated;
        }
      } else if (newHistory.typename === "contact") {
        const cleanedJsonString = newHistory.messagem.replace(
          /\\(?!["\\/bfnrtu])/g,
          ""
        );
        let json = JSON.parse(cleanedJsonString);

        newHistory.contactInfo = json;
      }

      const reply = HistorysFromRedux.find(
        (h) => h.replyid === newHistory.id || h.replyid === newHistory.messageid
      );
      if (reply) {
        newHistory.buttonResponse = reply.messagem;
      }

      if (newHistory.replyid) {
        const findAudit = HistorysFromRedux.find(
          (audit) =>
            audit.messageid === newHistory.replyid ||
            audit.id === newHistory.replyid
        );
        if (findAudit) {
          // if (
          //   findAudit.typename === "Interactive" ||
          //   findAudit.typename === "hsm"
          // ) {
          //   findAudit.buttonResponse = history.messagem;
          // }

          let id = findAudit.id ? findAudit.id : findAudit.messageid;

          newHistory.commentResponse = {
            id: id,
            username: findAudit.agente
              ? findAudit.username
              : createJSON(clientTest),
            mensagem:
              findAudit.typename === "contact" ? "Contato" : findAudit.messagem,
            mimetype: findAudit.mimetypeid,
            typename: findAudit.typename,
          };
        }
      }

      processed.push(newHistory);
    }

    // setTimeout(() => {
    setHistorys(processed);
    setLoadingHis(false);
    // }, 2000);
  }

  function isJson(item) {
    item = typeof item != "string" ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === "object" && item != null) {
      return true;
    }

    return false;
  }

  function tratarBOT(text) {
    let json = JSON.parse(text.replaceAll("\r\n", "\\n"));
    let options = json.options;
    if (parseInt(json.MIMETYPE) === 30) {
      return json.MSG;
    } else if (parseInt(json.mimetype) >= 33 && parseInt(json.mimetype) <= 37) {
      if (json.header) {
        return `*${json.header}*\\r\\n${json.msg}`;
      } else {
        return json.msg;
      }
    } else if (json.address) {
      return json.address;
    } else if (json.HSM_BUTTONS) {
      return json.URL;
    }

    return text;
  }

  const commentFilter = (comment) => {
    if (termText) {
      const mensagemTratada = isJson(comment.messagem)
        ? tratarBOT(comment.messagem)
        : comment.messagem;

      const commentFilter = mensagemTratada
        .toLowerCase()
        .includes(termText.toLowerCase());

      if (commentFilter) {
        return comment;
      } else {
        return;
      }
    } else {
      return comment;
    }
  };

  const ReturningCallbackIn = (
    queueid,
    inforetorno,
    recvcount,
    cdrid,
    mediaid,
    srvin,
    caller,
    called,
    cbackcount
  ) => {
    ReturningCallback(
      queueid,
      inforetorno,
      recvcount,
      cdrid,
      mediaid,
      srvin,
      caller,
      called
    )(dispatch);
    dispatch(returnListCallQueue("", queueid, "2", parseInt(cbackcount + 1)));
  };

  const handleAddContact = (contact, typeModal) => {
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontacts?number=${contact.telefone}&nome=&empresa=&contato=&codext=&email=`
      )
      .then((response) => {
        if (response.data.length > 0) {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact-historic");
            dispatch(GetDetailsContacts(false, response.data[0]));
          } else {
            dispatch(GetDetailsContacts(true, response.data[0], ""));
          }
        } else {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact-historic");
            dispatch(GetDetailsContacts(false, contact));
          } else {
            dispatch(GetDetailsContacts(true, "", contact.telefone));

            dispatch(AddNumberContact("", contact.telefone));
            dispatch(GetPhoneMidia([]));
          }
        }
      });
  };

  function handleChooseLinkContact(contact) {
    setLinkContact(contact);
    setViewContacts(false);
    setListSearchContacts([]);
    setTextSearchContacts("");
  }

  async function handleSearchContact(data, page) {
    const newData = {
      nome: data ? data : "",
      telefone: "",
      codext: "",
      email: "",
    };

    // bind.props.SearchingContacts(newData, "", "");
    // this.setState({ listSearchContacts: [] });
    setListSearchContacts([]);
    return await axios
      .get(
        `${
          connection_platform.type_connect
        }://${pathname}:${port}/conn/getcontacts_v3?number=&nome=${
          data ? data : ""
        }&empresa=&contato=&codext=&email=&page=${page}&limit=50`
      )
      .then((response) => {
        if (response.data !== "") {
          // this.setState({ listSearchContacts: response.data });
          setListSearchContacts(response.data);
          // return response.data;
        }
      })
      .catch((error) => {
        console.log("LOGINGENIUM ERROR BACKEND: ", error);
      });
  }

  function CloseModal(typemodal) {
    // this.props.GetDetailsContacts(false, "", "");
    dispatch(GetDetailsContacts(false, "", ""));
    // this.setState({
    //   linkContact: "",
    // });
    setLinkContact("");
    MicroModal.close("modal__linkAdd-contact-historic");
  }

  async function handleSaveContact(
    typemodal,
    contact,
    infousers,
    directDetails,
    detailsContacts
  ) {
    if (!detailsContacts.detailsget && detailsContacts.detailscontacts) {
      if (detailsContacts.detailscontacts.id) {
        await axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/linkcontact?idcontactold=${detailsContacts.detailscontacts.id}&idcontactnew=${linkContact.id}&idphone=${detailsContacts.detailscontacts.phone_id}`
          )
          .then((response) => {
            if (response.status === 200 && response.data !== "") {
              CloseModal("link");
              return response.data;
            }
          });
      } else {
        axios
          .get(
            `${connection_platform.type_connect}://${pathname}:${port}/conn/insertphone?phonetypeid=3&number=` +
              detailsContacts.detailscontacts.telefone +
              `&iduser=` +
              linkContact.id
          )
          .then((response) => {
            if (response.data !== "") {
              let data = response.data;
              axios
                .get(
                  `${connection_platform.type_connect}://${pathname}:${port}/conn/insertcontactphone?contactid=` +
                    linkContact.id +
                    `&phoneid=` +
                    data[0].id
                )
                .then((response) => {
                  CloseModal("link");
                  return response.data;
                });
            }
          });
      }
    }
  }

  useEffect(() => {
    if (InteractionsNumber.length !== 0) {
      if (InteractionsNumber.interactions.length !== 0) {
        setChangeInteractions(InteractionsNumber.interactions);
      } else {
        setChangeInteractions([]);
        setLoading(false);
      }
    }
  }, [InteractionsNumber]);

  useEffect(() => {
    if (HistorysFromRedux.length !== 0) {
      setLoadingHis(true);
      refactorHistory();
    } else {
      setHistorys([]);
      setLoadingHis(false);
    }
  }, [HistorysFromRedux]);

  useEffect(() => {
    if (contactId && !infoModal.telefone) {
      setContactId(contactId);
    } else if (infoModal.telefone) {
      setContactId(infoModal);
    } else if (IdContact) {
      setContactId(IdContact);
    }
  }, [infoModal, contactId, IdContact]);

  useEffect(() => {
    if (displayscreen === "monitoring") {
      setContactId(monitorclient);
    }
  }, [displayscreen, monitorclient]);

  return (
    <>
      <div
        className="modal micromodal-slide"
        id="modal__historico-atendimento-details"
        aria-hidden="true"
        role="dialog"
      >
        <div
          className="modal__overlay interactions-historic-modal-v2"
          tabIndex="-1"
        >
          <div
            className="modal__container modal__container-interacoes"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__agenda-pf__cliente__interacoes__title"
          >
            <header className="modal__header">
              <Typography.H2 color={"blue-selected-4"} weight={700}>
                Interações
              </Typography.H2>
              <button
                className="modal__close"
                aria-label="Close modal"
                onClick={(event) =>
                  exitModal(event, "modal__historico-atendimento-details")
                }
              ></button>
            </header>
            <main
              className="modal__content"
              id="modal__agenda-pf__cliente__interacoes__content"
            >
              <div className="modal__content__user-details__header">
                <div className="modal__content__user-details__header__info">
                  <UserPhoto size="large" />
                  {/* <div
                    className="user-photo"
                    // onClick={(event) => this.showUserMidia(event)}
                  >
                    <img src={CLIENTE} alt="" />
                  </div> */}
                  <div className="modal__content__user-details__header__info__text">
                    <Typography.H4 color={"black"}>
                      {createJSON(ContactId.cliente)}
                    </Typography.H4>

                    <Typography.H5 color={"gray-180"}>
                      {ContactId.telefone}
                    </Typography.H5>
                  </div>
                </div>
                <div className="modal__content__user-details__header__search">
                  <div className="modal__content__user-details__header__search__form">
                    <div className="block-header__search-box-nav">
                      <div className="block-header__search-box-content-input">
                        <Typography.H6 color={"gray-600"}>
                          Mensagem
                        </Typography.H6>
                        <input
                          type="text"
                          placeholder="Pesquisar mensagens..."
                          onChange={(e) => setMensagem(e.target.value)}
                          className="block-header__search-box-input"
                        />
                      </div>
                    </div>
                    <div className="modal__content__user-details__header__search__form__col modal__content__user-details__header__search__form__col--half">
                      <Typography.H6 color={"gray-600"}>De:</Typography.H6>

                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={ptBrLocale}
                      >
                        <DatePicker
                          value={dateInit}
                          onChange={(newValue) => setDateInit(newValue)}
                          maxDate={dateEnd}
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="modal__content__user-details__header__search__form__col modal__content__user-details__header__search__form__col--half">
                      <Typography.H6 color={"gray-600"}>Até:</Typography.H6>

                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={ptBrLocale}
                      >
                        <DatePicker
                          value={dateEnd}
                          onChange={(newValue) => setDateEnd(newValue)}
                          minDate={dateInit}
                        />
                      </LocalizationProvider>
                    </div>

                    <button
                      type="button"
                      onClick={(event) =>
                        loading
                          ? null
                          : getInteractions(
                              event,
                              ContactId.telefone,
                              ContactId.contactid
                            )
                      }
                      className={`modal__content__form__group__button btn-modals ${
                        loading ? "search-time" : ""
                      }`}
                    >
                      Buscar
                    </button>
                  </div>
                </div>
              </div>
              <div className="modal__content__user-details__content">
                <div className="modal__content__tabs__body__tab__result interaction-modal">
                  {loading ? (
                    <Loading.Paperplane fullPage={true} />
                  ) : changeInteractions.length > 0 &&
                    interactionsData.length > 0 ? (
                    <Table
                      className="table-fileShare"
                      data={interactionsData}
                      columns={columns}
                      fixedHeader
                      // fixedFirstColumn
                      // filtersActive={filtersActive}
                      // emptyState={emptyState}
                      // setEmptyState={setEmptyState}
                      // initialState={sortBy}
                      // screen="manager"
                    />
                  ) : (
                    <div className="modal__nully">
                      <div className="modal__nully-icon">
                        <IconMessageNull />
                      </div>
                      <div className="modal__nully-text">
                        <Typography.H4 color={"black"}>
                          Não há interações nesse período.
                        </Typography.H4>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </main>
            <footer className="modal__footer modal__footer--pull-right">
              {/* <span
                onClick={(event) =>
                  exitModal(event, "modal__agenda-pf__cliente__interacoes")
                }
              >
                <Typography.H4 color={"gray-180"}>Voltar</Typography.H4>
              </span> */}
              {/* <a
                className="modal__btn modal__btn-secondary"
                onClick={(event) =>
                  exitModal(event, "modal__agenda-pf__cliente__interacoes")
                }
              >
                Voltar
              </a> */}
            </footer>
          </div>
        </div>
      </div>

      {/* Modal de Historico */}

      <div
        className="modal micromodal-slide"
        id="modal__historico-atendimento-contact-2"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container modal-sizeInteractions"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__historico-atendimento__title"
          >
            <header className="modal__header">
              <div className="modal__back">
                <ArrowLeft onClick={(event) => closeHistory(event)} />
                <Typography.H2 color={"blue-selected-4"} weight={700}>
                  Interações
                </Typography.H2>
              </div>
              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
              ></button>
            </header>
            <main
              className="modal__content"
              id="modal__historico-atendimento__content"
            >
              <div className="hist-atd__info">
                <div className="hist-atd__info-items">
                  <Typography.H4 color={"blue-selected-5"}>
                    {createJSON(ContactId.cliente)}
                  </Typography.H4>
                  <div className="modal__info-container">
                    <div className="modal__info-total">
                      <IconDoc />
                      <span className="hist-atd__info-text">
                        Total de{" "}
                        <span className="hist-atd__counter">
                          {historys.length}
                        </span>{" "}
                        interações&#x28;s&#x29;
                      </span>
                    </div>
                    {(() => {
                      if (InfoUsers.permdownload === true) {
                        return (
                          <div className="hist-atd__info-pdf">
                            <span
                              onClick={() => exportPDFWithMethod(ContactId)}
                            >
                              <img
                                src={ICONPDFEXPORT}
                                alt="Icone de download para PDF"
                              />
                              Exportar PDF
                            </span>
                          </div>
                        );
                      }
                    })()}
                  </div>
                </div>
              </div>
              <div className="hist-atd__ctrls">
                <div className="hist-atd__ctrls-container">
                  <div className={"hist-atd__searchNew"}>
                    <Typography.H6 color={"gray-600"}>Mensagem</Typography.H6>
                    <input
                      type="text"
                      value={termText}
                      onChange={(event) => setTermText(event.target.value)}
                      className="hist-atd__search-input"
                      id="campopesquisartexto"
                      placeholder="Pesquisar..."
                    />
                  </div>
                  <div className="hist-atd__date-container">
                    <Typography.H6 color={"gray-600"}>De:</Typography.H6>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={ptBrLocale}
                    >
                      <DatePicker
                        value={dateInit}
                        onChange={(newValue) => setDateInit(newValue)}
                        maxDate={dateEnd}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="hist-atd__date-container">
                    <Typography.H6 color={"gray-600"}>Até:</Typography.H6>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={ptBrLocale}
                    >
                      <DatePicker
                        value={dateEnd}
                        onChange={(newValue) => setDateEnd(newValue)}
                        minDate={dateInit}
                      />
                    </LocalizationProvider>
                  </div>
                  <button
                    className={`hist-atd__search-btn btn-modals ${
                      loadingHis ? "search-time" : ""
                    }`}
                    onClick={() =>
                      loadingHis
                        ? null
                        : searchHistoryContact(ContactId.telefone)
                    }
                  >
                    Filtrar Data
                  </button>
                </div>
              </div>
              <div className="hist-atd__content">
                <div className="hist-atd__channel-info">
                  <img
                    className="hist-atd__channel-info-icon"
                    style={{ display: "none" }}
                    src={WHATSAPP}
                    alt=""
                    width="20"
                    height="20"
                  />
                  <Typography.H5 color={"gray-180"}>Interações</Typography.H5>
                </div>
                <div className="hist-atd__wrapper">
                  <div className="hist-atd__channel">
                    <div className="hist-atd__channel-chat active">
                      {loadingHis ? (
                        <Loading.Paperplane fullPage={true} />
                      ) : historys.length > 0 && historys[0].midia !== "Voz" ? (
                        historys.filter(commentFilter).map((history, index) => {
                          let dataHoraEnvio = "";
                          if (history.data_hora_envio) {
                            const getData = history.data_hora_envio.split(" ");
                            const organizeData = getData[0]
                              .split("/")
                              .reverse()
                              .join("/");
                            dia = organizeData;
                          } else if (history.dataenvio) {
                            dia = history.dataenvio
                              .split("/")
                              .reverse()
                              .join("/");
                          }

                          if (dia != auxdia) {
                            dia = dia;
                            auxdia = dia;
                          } else {
                            auxdia = dia;
                            dia = "";
                          }

                          let mensagem_tratada = "";
                          if (history.caption) {
                            mensagem_tratada = history.caption;
                          } else if (history.contactInfo) {
                            mensagem_tratada = " ";
                          } else {
                            mensagem_tratada = history.messagem.replace(
                              /\r\n|\r|\n/g,
                              "\n"
                            );
                          }

                          return (
                            <InteractionComment
                              key={index}
                              id={
                                history.messageid
                                  ? history.messageid
                                  : history.id
                              }
                              inputSearch={termText}
                              text={mensagem_tratada}
                              type={
                                mimetypesPrincipal.includes(history.typename)
                                  ? "attachment"
                                  : ""
                              }
                              date={{
                                horaEnvio: history.data_hora_envio
                                  ? history.data_hora_envio.split(" ")[1]
                                  : new Date(
                                      history.datesend
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    }),
                                horaLida: history.dateread,
                                horaError: history.dateerror,
                                dia: dia ? new Date(dia) : "",
                              }}
                              attachment={history.file}
                              size={history.filesize}
                              mimetypeId={history.mimetypeid}
                              mimetype={history.mimetype}
                              typeName={history.typename}
                              name={
                                history.agente
                                  ? history.username
                                  : createJSON(ContactId.cliente)
                              }
                              direction={
                                history.agente && history.mon_type_id === 0
                                  ? "right"
                                  : "left"
                              }
                              buttons={history.buttons}
                              botId={history.botid}
                              reply={history.commentResponse}
                              buttonResponse={history.buttonResponse}
                              location={history.location}
                              allInfo={history}
                              titleOptions={false}
                              contactInfo={history.contactInfo}
                              contactLinkAdd={handleAddContact}
                              actionCallInfo={() =>
                                MicroModal.close(
                                  "modal__historico-atendimento-contact-2"
                                )
                              }
                            />
                          );
                        })
                      ) : (
                        <div className="modal__nully">
                          <div className="modal__nully-icon">
                            <IconMessageNull />
                          </div>
                          <div className="modal__nully-text">
                            <Typography.H4 color={"black"}>
                              Não há interações nesse período.
                            </Typography.H4>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "none",
          position: "absolute",
          right: "-9999999999999999999999999px",
          top: 0,
        }}
      >
        <PDFExport
          ref={(component) => (pdfExportComponent = component)}
          paperSize="A4"
        >
          <PdfDocument
            history={historys}
            cliente={ContactId.cliente}
            datapdfinit={dateInit}
            datapdfend={dateEnd}
            numero={ContactId.telefone}
          />
        </PDFExport>
      </div>
      {/* Fim do Modal de Historico */}

      {/* Modal de Vincular/Adicionar Contato */}
      <div
        className="modal micromodal-slide"
        id="modal__linkAdd-contact-historic"
        aria-hidden="true"
        role="dialog"
      >
        <div className="modal__overlay" tabIndex="-1">
          <div
            className="modal__container"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal__linkAdd-contact__title"
          >
            <header className="modal__header">
              <Typography.H2 color={"blue-selected-4"} weight={700}>
                {typeModal === "link"
                  ? "Vincular contato"
                  : "Adicionar contato"}
              </Typography.H2>
              <button
                className="modal__close"
                aria-label="Close modal"
                data-micromodal-close
                onClick={(e) => CloseModal(typeModal)}
              ></button>
            </header>
            <main
              className="modal__content"
              id="modal__linkAdd-contact__content"
            >
              {!DetailsContacts.detailsget &&
                DetailsContacts.detailscontacts && (
                  <>
                    <Typography.H4 color={"gray-180"}>
                      Selecione o contato que você deseja vincular a este número{" "}
                      {DetailsContacts.detailscontacts.telefone ||
                        DetailsContacts.detailscontacts.number}
                      .
                    </Typography.H4>

                    <FieldContainer title="Contato" required htmlFor="">
                      <div
                        className={
                          viewContacts
                            ? "select card--no-mg active"
                            : "select card--no-mg"
                        }
                      >
                        <button
                          className="select__btn"
                          type="button"
                          id="mult-filter-inside"
                          onClick={() =>
                            // this.setState({
                            //   viewContacts: !this.state.viewContacts,
                            // })
                            setViewContacts(!viewContacts)
                          }
                        >
                          {linkContact ? linkContact.name : "Selecione..."}
                          <i className="select__icon material-icons">
                            keyboard_arrow_right
                          </i>
                        </button>
                        <div className="options options--advanced">
                          <div className="options--advanced__search-box">
                            <div className="full-search">
                              <input
                                type="text"
                                value={textSearchContacts}
                                placeholder="Busca..."
                                onChange={(event) => {
                                  // this.setState({
                                  //   textSearchContacts: event.target.value,
                                  // });
                                  setTextSearchContacts(event.target.value);
                                }}
                                onKeyDown={(event) => {
                                  if (event.keyCode === 13) {
                                    handleSearchContact(textSearchContacts, 1);
                                  }
                                }}
                              />
                              <button
                                type="button"
                                className="full-search__btn"
                                onClick={() =>
                                  handleSearchContact(textSearchContacts, 1)
                                }
                              >
                                <i className="material-icons">search</i>
                              </button>
                            </div>
                          </div>
                          <div className="options--advanced__filter-box">
                            <div className="options--advanced__filter-box__content">
                              <ul className="checkbox checkbox__list">
                                {listSearchContacts.map((contact) => (
                                  <li
                                    className="checkbox__item"
                                    key={contact.id}
                                    onClick={() => {
                                      handleChooseLinkContact(contact);
                                    }}
                                  >
                                    <label
                                      htmlFor={
                                        "checkbox-service" + contact.name
                                      }
                                    >
                                      {createJSON(contact.name)}
                                    </label>
                                    <label
                                      htmlFor={
                                        "checkbox-service" + contact.number
                                      }
                                    >
                                      {contact.number}
                                    </label>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </FieldContainer>
                  </>
                )}
            </main>
            <div className="modal-box__footer">
              <button
                className="button_cancel"
                onClick={(e) => CloseModal(typeModal)}
              >
                <span>Cancelar</span>
              </button>
              <button
                className="button_save"
                onClick={(e) =>
                  handleSaveContact(
                    typeModal,
                    ContactId,
                    InfoUsers,
                    false,
                    DetailsContacts
                  )
                }
              >
                <span>Salvar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Fim do Modal de Vincular/Adicionar Contato */}
    </>
  );
}
